import { useCallback, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useCompanyPermissions } from '../../../hooks/useCompanyPermissions';
import { payterContext } from '../../../hooks/usePayter';
import { Button, ButtonType, Card, MODAL_TYPES, Skeleton, useGlobalModalContext } from '../../_ui';
import ConnectPayterAccount from './ConnectPayterAccount';
import TerminalHeader from './TerminalHeader.component';
import TerminalTable from './TerminalTable.component';

export enum PAYTER_VIEW {
  CONNECT_ACCOUNT = 'connect-account',
}
const PayterTerminal = () => {
  const { t } = useTranslation();

  const payterConsumer = useContext(payterContext);
  const { isPayterConnected, company, isCompanyLoading } = payterConsumer;
  const { canCreateTerminals, canEditTerminals, canDeleteTerminals } = useCompanyPermissions(
    company?.id,
  );

  const { showModal, hideModal } = useGlobalModalContext();

  const onCloseModel = useCallback(() => {
    hideModal();
    localStorage.removeItem(PAYTER_VIEW.CONNECT_ACCOUNT);
  }, [hideModal]);

  const handlePayterAccount = useCallback(() => {
    showModal(MODAL_TYPES.INFO_MODAL, {
      title: t('connect_payter_account'),
      overflow: 'auto',
      width: '540px',
      height: 'fit-content',
      onRenderBody: () => <ConnectPayterAccount companyDetails={company} />,
      onIconClick: onCloseModel,
      shouldCloseOnOverlayClick: false,
      headerClass: 'pt-5 mb-2',
    });
  }, [showModal, t, company, onCloseModel]);

  useEffect(() => {
    if (localStorage.getItem(PAYTER_VIEW.CONNECT_ACCOUNT)) {
      handlePayterAccount();
    }
  }, [handlePayterAccount]);

  return (
    <Card className='p-5 h-fit'>
      <TerminalHeader allowTerminalCreation={canCreateTerminals} />
      {isPayterConnected ? (
        <TerminalTable
          allowTerminalEdits={canEditTerminals}
          allowTerminalDeletion={canDeleteTerminals}
        />
      ) : isCompanyLoading ? (
        <Skeleton height='h-[40px]' width='w-[196px]' />
      ) : (
        canCreateTerminals && (
          <Button
            label={t('connect_payter_account')}
            type={ButtonType.SECONDARY}
            isLoading={isCompanyLoading}
            onClick={handlePayterAccount}
            dataTestId='connect-payter-button'
          />
        )
      )}
    </Card>
  );
};

export default PayterTerminal;
